import { isObject, objectEqual } from "./object"

/**
 * Compares two values for deep equality (objects, arrays, primitives).
 * @param {*} v1
 * @param {*} v2
 * @returns {boolean}
 */
const elementsEqual = (v1, v2) => {
  if (typeof v1 !== typeof v2) return false
  if (isObject(v1)) return objectEqual(v1, v2)
  if (Array.isArray(v1)) return arrayEquals(v1, v2)
  return v1 === v2
}

export function arrayEquals(arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return false
  }
  if (arr1 === arr2) {
    return true
  }
  if (arr1 == null || arr2 == null) {
    return false
  }
  if (arr1.length !== arr2.length) {
    return false
  }

  for (let i = 0; i < arr1.length; i++) {
    if (!elementsEqual(arr1[i], arr2[i])) {
      return false
    }
  }

  return true
}

export function isEmptyArray(arr) {
  if (arr == null || !Array.isArray(arr)) {
    return true
  }
  return arr.length === 0
}

export function isEmptySet(values) {
  if (values == null || !(values instanceof Set)) {
    return true
  }

  return values.size === 0
}
